export default __webpack_public_path__ + "static/media/tutorial3-3.b34878be.png";